/**
 * Web Health status line: the twin of `HealthStatusLine.tsx`.
 *
 * The heart beside one line of text. Working: 13 px medium with the shimmer
 * sweep between muted ink and ink (`.tabbio-health-status-text` narrows the
 * shared `.tabbio-shimmer-text` gradient to the Health inks). Settled: a still
 * 15 px sentence in soft ink. The same span renders every stage, so the text
 * updates in place; the live region announces each new stage.
 */
// Explicit `.web`: the web ShimmerText takes different props from the native
// one, and TypeScript does not apply Metro's platform resolution.
import { ShimmerText } from '@/components/assistant-ui/shimmer-text.web';
import { HealthHeart } from './HealthHeart';
import { HEALTH_HEART_DEFAULT_SIZE } from './health-heart-path';
import type { HealthStatusLineProps } from './health-props';

export type { HealthStatusLineProps };

export function HealthStatusLine({
  text,
  working,
  align = 'center',
  heartSize = HEALTH_HEART_DEFAULT_SIZE,
}: HealthStatusLineProps) {
  return (
    <div
      className="tabbio-health-status"
      data-align={align}
      data-working={working ? 'true' : 'false'}
    >
      <span className="tabbio-health-status-heart">
        <HealthHeart size={heartSize} state={working ? 'working' : 'resting'} />
      </span>
      <ShimmerText
        active={working}
        className="tabbio-health-status-text"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {text}
      </ShimmerText>
    </div>
  );
}

export default HealthStatusLine;
